import React from "react";
import { Box, Dialog, Text, Button, VirtuazlizedList } from "common";
import { useStyles } from "./BulkJobs.style";

interface IProps {
  open: boolean;
  onClose: () => void;
  errorList: string[];
}

const BulkJobModal: React.FC<IProps> = ({ open, onClose, errorList }) => {
  const { wrapText } = useStyles();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      dialogTitle={
        <Text
          style={{ fontWeight: "600", fontSize: "large" }}
          color="error.main"
        >
          Upload Errors
        </Text>
      }
    >
      <Box px={2} pb={2}>
        <Box m="8px">
          {errorList.length > 5 ? (
            <Box
              className={wrapText}
              style={{ width: "500px", maxWidth: "600px" }}
            >
              <VirtuazlizedList
                itemData={errorList}
                height={170}
                width={500}
                itemSize={50}
                itemCount={errorList.length}
                containerStyles={{
                  height: 170,
                  width: "100%",
                }}
              />
            </Box>
          ) : (
            errorList?.map((error, index) => (
              <Text
                key={`error-${index}`}
                style={{
                  fontSize: "1rem",
                  fontWeight: "400",
                  lineHeight: "1.5",
                }}
              >
                {error}
              </Text>
            ))
          )}
        </Box>
        <Box display="flex" justifyContent="flex-end">
          <Button
            round
            variant="contained"
            color="primary"
            data-testid="close-view-error-btn"
            onClick={onClose}
          >
            Close
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default BulkJobModal;
